import type { CancelablePromise } from "../client"
import { OpenAPI } from "../client"
import { request as __request } from "../client/core/request"

export type ProductListItemDTO = {
  id: string
  sku: string
  name: string
  manufacturer: string
  supplier?: string
  EAN?: string
  unit: string
  is_active: boolean
  is_service: boolean
  requires_batch_tracking?: boolean
  requires_expiration_date?: boolean
  acronym: string
  created_at: string
  default_min_qty?: number
  current_price_netto?: number
  current_price_currency?: string
  last_purchase_price_netto?: number
}

export type ProductListResponseDTO = {
  items: ProductListItemDTO[]
  total: number
  page: number
  page_size: number
}

export const ProductListApi = {
  getProductListPage: (params?: {
    search?: string
    manufacturer_id?: string
    supplier_id?: string
    is_service?: boolean
    page?: number
    page_size?: number
    sort_by?: "sku" | "name" | "manufacturer" | "supplier" | "created_at"
    sort_dir?: "asc" | "desc"
  }): CancelablePromise<ProductListResponseDTO> => {
    return __request(OpenAPI, {
      method: "GET",
      url: "/v1/products/list",
      query: params ?? {},
    })
  },
}
